export default {"src":"/_next/static/media/yahoo.a05b17ff.svg","height":34,"width":99,"blurWidth":0,"blurHeight":0};